import { useQuery } from "@tanstack/react-query";
import { millisecondsInMinute } from "date-fns";
import { useParams } from "react-router-dom";
import {
  Document,
  Doctor,
  PatientAttributes,
  requestTypeFromUrlParser,
} from "../../../interfaces";
import { api } from "../../../context";
import { isAxiosError } from "axios";

interface DocumentData {
  patient: PatientAttributes;
  doctor: Omit<Doctor, "signature">;
  medicalDocument: Document;
  medicalDocumentPDFReadUrl: string;
}

export const useDocument = (verificationCode?: string) => {
  const { documentType: documentTypeFromUrl, requestId } = useParams();
  const documentType = documentTypeFromUrl
    ? requestTypeFromUrlParser[documentTypeFromUrl]
    : undefined;
  const code = verificationCode ?? requestId;

  return useQuery({
    queryKey: ["verify-document", documentType, code],
    queryFn: () => {
      return api<DocumentData>({
        url: `/medical-document/${documentType}/${code}`,
      });
    },
    enabled: requestId ? true : false,
    staleTime: 5 * millisecondsInMinute,
    retry: (_, error) => {
      if (isAxiosError(error) && error.response?.status === 404) {
        return false;
      }
      return true;
    },
  });
};
